import { useTranslation } from 'react-i18next'
import { Seo } from '../components/Seo'
import { Dropzone } from '../components/Dropzone'

export function Home() {
  const { t } = useTranslation()

  return (
    <main className="page">
      <Seo title={t('seo.homeTitle')} description={t('seo.homeDesc')} path="/" />

      <section className="hero container">
        <span className="pill">{t('home.heroBadge')}</span>
        <h1>
          {t('home.h1a')} <span className="grad">{t('home.h1b')}</span>
        </h1>
        <p className="sub">{t('home.sub')}</p>
        <Dropzone />
      </section>

      <section className="container section" aria-labelledby="how-title">
        <h2 id="how-title">{t('home.howTitle')}</h2>
        <div className="grid-3">
          {([1, 2, 3] as const).map((n) => (
            <div className="card" key={n}>
              <div className="step-num">{n}</div>
              <h3>{t(`home.step${n}t`)}</h3>
              <p>{t(`home.step${n}d`)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container section" aria-labelledby="feat-title">
        <h2 id="feat-title">{t('home.featTitle')}</h2>
        <div className="grid-2">
          <div className="card">
            <div className="feat-icon" aria-hidden="true">🖥️</div>
            <h3>{t('home.f1t')}</h3>
            <p>{t('home.f1d')}</p>
          </div>
          <div className="card">
            <div className="feat-icon" aria-hidden="true">🗂️</div>
            <h3>{t('home.f2t')}</h3>
            <p>{t('home.f2d')}</p>
          </div>
          <div className="card">
            <div className="feat-icon" aria-hidden="true">🌗</div>
            <h3>{t('home.f3t')}</h3>
            <p>{t('home.f3d')}</p>
          </div>
          <div className="card">
            <div className="feat-icon" aria-hidden="true">🕘</div>
            <h3>{t('home.f4t')}</h3>
            <p>{t('home.f4d')}</p>
          </div>
        </div>
      </section>
    </main>
  )
}
